import type { RouteRecordRaw } from 'vue-router'
import AdminLayout from '../components/layout/AdminLayout.vue'

const adminRoutes: RouteRecordRaw[] = [
  {
    path: '/admin/login',
    name: 'admin-login',
    component: () => import('../views/AdminLoginView.vue'),
    meta: {
      title: 'Staff Sign In - Achiraya Studio Admin',
      requiresGuest: true,
      hideLayout: true
    }
  },
  {
    path: '/admin',
    component: AdminLayout,
    meta: { requiresStaff: true },
    children: [
      {
        path: '',
        name: 'admin-dashboard',
        component: () => import('../views/DashboardView.vue'),
        meta: { title: 'Admin Dashboard - Achiraya Studio', requiresStaff: true }
      },
      {
        path: 'bookings',
        name: 'admin-bookings',
        component: () => import('../views/BookingsView.vue'),
        meta: { title: 'Bookings - Achiraya Studio Admin', requiresStaff: true }
      },
      {
        path: 'bookings/new',
        name: 'admin-booking-new',
        component: () => import('../views/NewBookingView.vue'),
        meta: { title: 'New Walk-in Booking - Achiraya Studio Admin', requiresStaff: true }
      },
      {
        path: 'bookings/:id',
        name: 'admin-booking-detail',
        component: () => import('../views/BookingDetailView.vue'),
        meta: { title: 'Booking Details - Achiraya Studio Admin', requiresStaff: true }
      },
      {
        path: 'tasks',
        name: 'admin-tasks',
        component: () => import('../views/TasksView.vue'),
        meta: { title: 'Tasks - Achiraya Studio Admin', requiresStaff: true }
      },
      {
        path: 'packages',
        name: 'admin-packages',
        component: () => import('../views/PackagesView.vue'),
        meta: { title: 'Packages - Achiraya Studio Admin', requiresStaff: true }
      },
      {
        path: 'staffs',
        name: 'admin-staffs',
        component: () => import('../views/StaffsView.vue'),
        meta: { title: 'Staff Management - Achiraya Studio Admin', requiresStaff: true }
      },
      {
        path: 'settings',
        name: 'admin-settings',
        component: () => import('../views/SettingsView.vue'),
        meta: { title: 'Settings - Achiraya Studio Admin', requiresStaff: true }
      },
      {
        path: 'executive_summaries',
        name: 'admin-executive-summaries',
        component: () => import('../views/ExecutiveSummariesView.vue'),
        meta: { title: 'Executive Summaries - Achiraya Studio Admin', requiresStaff: true }
      }
    ]
  }
]

export default adminRoutes
